module.exports = __webpack_public_path__ + "static/media/stands-out.731c173e.png";